const Circle = () => {
  return (
    <div className="w-4 h-4">
      <div className="border border-blue shadow-sm rounded-full w-4 h-4"></div>
    </div>
  );
};

export default Circle;
